<template>
	<!-- 基本信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">基本信息</div>
		</div>
		<div class="information_content">
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					店铺
				</div>
				<div class="input_el input_span">
					<div class="newipt" style="display: flex;">
						<el-select
                :disabled="(isChakan || isEdit ||system < 5) && isEditSellerId"
								v-model="formData.sellerId"
								class="width67 "
								placeholder="请选择"
                @change="changeSellerId"
						>
							<el-option
									v-for="item in dianpuList"
									:key="item.sellerId"
									:label="item.shopName"
									:value="item.sellerId"
							></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					父SKU
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
								class="width67"
                :disabled="(isChakan ||system < 5) && isEditSku"
								v-model="formData.sku"
								@input="inputSkuchange"
						></el-input>
						<el-button v-if="(!isChakan && system == 5 && !isEdit) ||!isEditSku" style="margin-left: 10px" type="primary" @click="createSku">生成编号</el-button>
					</div>
				</div>
			</div>

			<div
					class="information_input"
					style="margin-bottom:12px;"
			>
				<div class="information_Title">
					<span class="tips">*</span>
					标题
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
                :disabled="isChakan ||system < 5"
								type="text"
								class="width85"
								v-model="formData.name"
								maxlength="75"
								show-word-limit
								@input="inputNamechange"
						>
						</el-input>
						<el-tooltip placement="right-start"  effect="light" :open-delay="300" v-if="system == 5 && !isChakan">
							<template slot="content">
								首字母大写
							</template>
							<el-button style="background: rgb(245,245,245);color: #b7b4b4" type="primary" @click="capitalizeFirstLetter">A a</el-button>
						</el-tooltip>
					</div>
					<div style="margin-top: 5px">
            波兰站点推荐使用波兰文或英文，捷克站点推荐使用捷克捷克文
          </div>
				</div>
			</div>
      <div
				class="information_input"
				style="margin-bottom:20px;"
		>
        <div class="information_Title">
          英文刊登
        </div>
        <div  style="margin-top: 6px">
          <el-checkbox :disabled="isChakan || system < 5" v-model="formData.checked">英文刊登模式，Allegro产品前台会自动将标题、描述转换波兰文</el-checkbox>
        </div>
		</div>
		</div>
	</div>
</template>
<script>
	import {ajaxGet, ajaxPost, Baseurl} from "../../../api/api/api";
	export default {
		name: 'baseInfoComp',
		data() {
			return {
        //编辑状态可以修改店铺
        isEditSellerId:false,
        isEditSku:false,
        //角色id
        staffId:JSON.parse(localStorage.getItem('role')).rid,
				addStatus:'add',//判断是新增还是编辑
				isEditLeimu:false,//编辑状态修改了类目
				//店铺List
				dianpuList:[],
				formData:{
					//店铺id
					sellerId:'',
          //parentSku
          sku:'',
          name:'',//标题,
          checked:false,
				},
			}
		},
    props: {
      isChakan: {
        type: Boolean,
        default:false,
      },
      isEdit: {
        type: Boolean,
        default:false,
      },
      system: {
      type: Number,
      default:5,
    }
    },
		methods: {
      initData(dianpuList){
        this.dianpuList = dianpuList
        this.isEditLeimu = false
        this.formData.sellerId = undefined
        this.formData.name = undefined
        this.formData.sku = undefined
        this.formData.checked = false

      },
			//生成sku编号
			createSku(){
				const paramsData = {
					staffId:this.staffId
				}
				const API = Baseurl + '/commonSettingController/getCommonSettingByStaffId'
				ajaxPost(API, paramsData)
						.then((res) => {
							if(res.data.code === 200) {
								this.formData.sku = res.data.data.sku
								this.$emit('changeSku',this.formData.sku)
							}else{
								this.$message.error(res.data.data)
							}
						})
			},
			inputSkuchange(val){
				if (val){
					this.$emit('changeSku',val)
				}
			},
			inputNamechange(val){
				if (val){
					this.$emit('changeName',val)
				}
			},
      changeSellerId(val){
        this.$emit('setSellerId',val)
      },
			//首字母大写
			capitalizeFirstLetter() {
				this.formData.name = (this.formData.name.toLowerCase().replace(/\b[a-z]/g, function(match) {
					return match.toUpperCase();
				}))
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
</style>
